import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Modal, Button } from 'ancestry-ui-react';

export default function AlertConfirmDelete({
  cancelLabel,
  confirmLabel,
  deleteItem,
  itemForDelete,
  itemForDeleteTitle,
  setItemForDelete,
  submitLabel,
}) {
  const dispatch = useDispatch();
  const handleClose = () => setItemForDelete(null);

  const handleDelete = () => {
    dispatch(deleteItem());
    handleClose();
  }

  return (
    <Modal
      open={!!itemForDelete}
      onClose={handleClose}
      closeOnBkgClick
      hideCloseBtn
    >
      <div className='alert__modal-body'>
        <FormattedMessage
          {...confirmLabel}
          {...(itemForDeleteTitle && { values: { name: itemForDeleteTitle } })}
        />
      </div>
      <div className='alert__modal-actions'>
        <Button onClick={handleClose} className='ancBtn noBorder cancel'>
          <FormattedMessage {...cancelLabel} />
        </Button>
        <Button onClick={handleDelete} className='ancBtn noBorder submit'>
          <FormattedMessage {...submitLabel} />
        </Button>
      </div>
    </Modal>
  );
}

AlertConfirmDelete.propTypes = {
  cancelLabel: PropTypes.object.isRequired,
  confirmLabel: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
  itemForDelete: PropTypes.object.isRequired, // object can be null or object type
  itemForDeleteTitle: PropTypes.string,
  setItemForDelete: PropTypes.func.isRequired,
  submitLabel: PropTypes.object.isRequired,
};
